import React from "react";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-dark-border py-12 px-6">
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-6">
        <div className="flex gap-6">
          <a
            href="https://github.com/AndreasFWallin"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link text-xl text-neutral-500 hover:text-white"
          >
            <AiFillGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/andreas-wallin-abb4b515a"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link text-xl text-neutral-500 hover:text-white"
          >
            <FaLinkedinIn />
          </a>
        </div>
        <p className="text-xs text-neutral-600">
          © {year} Andreas Wallin
        </p>
      </div>
    </footer>
  );
}

export default Footer;
